<section class="hero-section">
  <img src="assets/images/hero-bg.png" class="hero-bg" alt="" />

  <div class="section-content">
    <h1 class="main-title">Discover Exclusive</h1>
    <h1>Parties in Your Area</h1>
    <p class="main-subtitle">Connect with party-goers and hosts. Find the hottest events, chat in real-time, and never miss out on the action.</p>
    <div class="store-buttons">
      <a href="https://play.google.com/store/apps/details?id=com.dropaddy" class="store-btn">
        <svg class="store-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.18 23.76c.3.17.64.24.98.2l13.09-7.57-2.76-2.76-11.31 10.13z" fill="#EA4335"/>
          <path d="M22.53 10.19 19.2 8.27l-3.1 3.1 3.1 3.1 3.36-1.94a1.79 1.79 0 0 0 0-3.34z" fill="#FBBC04"/>
          <path d="M3.16.24A1.79 1.79 0 0 0 2 1.88v20.24a1.79 1.79 0 0 0 1.18 1.64L14.87 12 3.16.24z" fill="#4285F4"/>
          <path d="M4.16.04 17.25 7.6l-2.76 2.76L3.16.24A1.79 1.79 0 0 1 4.16.04z" fill="#34A853"/>
        </svg>
        <div class="store-text">
          <span class="store-label">GET IT ON</span>
          <span class="store-name">Google Play</span>
        </div>
      </a>
      <a href="#" class="store-btn">
        <svg class="store-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
        <div class="store-text">
          <span class="store-label">DOWNLOAD ON THE</span>
          <span class="store-name">App Store</span>
        </div>
      </a>
    </div>
  </div>

  <!-- Stats Bar -->
  <div class="stats-bar">
    <div class="stats-grid">
      @for (stat of stats; track stat.label; let i = $index; let last = $last) {
        <div class="stat-item">
          <h3>{{ animatedValues[i] }}</h3>
          <p>{{ stat.label }}</p>
        </div>
        @if (!last) {
          <div class="stat-divider"></div>
        }
      }
    </div>
  </div>
</section>
